import { IHost, IHostFetch } from 'src/models/IHost';
import {
  AddAvatarAction,
  AddHostAction,
  ClearHostResultAction,
  DeleteHostAction,
  DeleteStripeIdAction,
  GetHostsAction,
  HostActionEnum,
  ResultAddAvatarAction,
  ResultAddHostAction,
  ResultDeleteHostAction,
  ResultDeleteStripeIdAction,
  ResultGetHostsAction,
  ResultUpdateHostAction,
  UpdateHostAction
} from './types';

export const HostActionCreators = {
  getHosts: (): GetHostsAction => ({
    type: HostActionEnum.REQUEST_HOSTS
  }),
  resultGetHosts: (data: IHostFetch[], status: number): ResultGetHostsAction => ({
    type: HostActionEnum.RESULT_HOSTS,
    data,
    status
  }),
  addHost: (data: IHost): AddHostAction => ({
    type: HostActionEnum.REQUEST_ADD_HOST,
    data
  }),
  resultAddHost: (data: IHostFetch, status: number): ResultAddHostAction => ({
    type: HostActionEnum.RESULT_ADD_HOST,
    data,
    status
  }),
  updateHost: (currentHost: IHostFetch, id: string | number): UpdateHostAction => ({
    type: HostActionEnum.REQUEST_UPDATE_HOST,
    currentHost,
    id
  }),
  resultUpdateHost: (status: number): ResultUpdateHostAction => ({
    type: HostActionEnum.RESULT_UPDATE_HOST,
    status
  }),
  deleteHost: (id: number): DeleteHostAction => ({
    type: HostActionEnum.REQUEST_DELETE_HOST,
    id
  }),
  resultDeleteHost: (status: number): ResultDeleteHostAction => ({
    type: HostActionEnum.RESULT_DELETE_HOST,
    status
  }),
  deleteStripeId: (id: number): DeleteStripeIdAction => ({
    type: HostActionEnum.REQUEST_DELETE_STRIPE_ID,
    id
  }),
  resultDeleteStripeId: (data: string, status: number): ResultDeleteStripeIdAction => ({
    type: HostActionEnum.RESULT_DELETE_STRIPE_ID,
    data,
    status
  }),
  addAvatar: (id: number, file: File): AddAvatarAction => ({
    type: HostActionEnum.REQUEST_ADD_AVATAR,
    id,
    file
  }),
  resultAddAvatar: (status: number): ResultAddAvatarAction => ({
    type: HostActionEnum.RESULT_ADD_AVATAR,
    status
  }),
  clearHostResult: (): ClearHostResultAction => ({
    type: HostActionEnum.CLEAR_HOST_RESULT
  })
};
